import $ from 'jquery';
/***
 Toggle class on hover to allow for fade non-active items
*/

$('.js--faded-hoverItem').hover(function () {
    $('.js--faded-hoverContainer').toggleClass('js--hover-fade');
    $(this).toggleClass('js--hover-fade-item');
});